import { Environment } from './environment.interface';

export const environment: Environment = {
  accountsServerFirebaseConfig: {
    apiKey: 'AIzaSyCSarJlYIXqBHIldpO5bLduUBcpCgZG038',
    appId: '1:922086213934:web:154b0865767840996e52bf',
    authDomain: 'santandermx-as-dev.firebaseapp.com',
    messagingSenderId: '922086213934',
    projectId: 'santandermx-as-dev',
    storageBucket: 'santandermx-as-dev.appspot.com',
  },
  apiUrl: 'https://dev.api.homein.mx',
  apiUrl2: 'https://dev.api2.homein.mx',
  apiUrlAccountsServer: 'https://dev.accounts-server.homein.mx',
  appUrl: 'https://dev.homein.mx',
  firebaseConfig: {
    apiKey: 'AIzaSyCf3xHfuxqVT16rVoP-fsqPWfM5pIk1dio',
    appId: '1:756336661481:web:eb3ead454764ceb3aaf178',
    authDomain: 'dev.homein.mx',
    measurementId: 'G-WJWL0RP4FN',
    messagingSenderId: '756336661481',
    projectId: 'santandermx-ha-dev',
    storageBucket: 'santandermx-ha-dev.appspot.com',
  },
  googleMaps: {
    embedApiKey: 'AIzaSyCLamC18AcGqd4XPNBguEiyNdDeS7naDvY',
  },
  name: 'dev',
  partners: {
    moving: {
      appUrl: 'https://luchosabeingles.dev.mudango.com/cotizar/mudanza',
      reference: 'homein',
    },
    warehouse: {
      appUrl: 'https://luchosabeingles.dev.mudango.com/bodegas/bot/cotizar-bodega',
      reference: 'homein',
    },
  },
  platformWhatsAppPhoneNumber: '+56950866839',
  production: false,
  recaptchaSiteKey: '6LfiulwqAAAAAOkncxKGY6EwAIaD-QZJZ5jwaXd1',
  typesenseConfig: {
    apiKey: 'blMA3AHUp7jBtCrw4G88IPeUbT3pywmf',
    url: 'https://dev.search.homein.mx',
  },
  usingMocks: false,
};
